import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "pricing section",
  id: "pricing"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "section__title--primary" }, "Pricing", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pricing_cards = _resolveComponent("pricing-cards")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_pricing_cards)
  ]))
}